import React from "react";
import { Switch, Route, withRouter} from "react-router-dom";
import loadable from "@/route";
import App from "./page/index";
import { axios } from "marmot_design_ui";
import Cookies from "js-cookie";
import "./assets/style/commonStyle.less";
import "handsontable/dist/handsontable.full.css";


if (process.env.NODE_ENV === 'development') {
  axios.setToken('0BB5A2D4100054B162BFE5F218150AE370832276180619264019427955570337345');
  sessionStorage.setItem(
      'feConfig',
      JSON.stringify({
        apiHost: 'api-test.dbxiao.cn',
        platformName: '教育数据中台',
      }),
  );
} else {
  axios.setToken(Cookies.get('token') || '');
}
// 首页
const Portal = loadable(() => import("./page/portal/index"));


const teacher = loadable(() => import("@/page/register/teacher"));

const MyNotice = loadable(() => import("@/page/notice/index"));

const ClubDetail = loadable(() => import("@/page/club-detail"));

const PortalTeam = loadable(() => import("@/page/portal-my-group"));

const More = loadable(() => import("@/page/portal/components/more"));



const Bespeak = loadable(()=>import('@/page/bespeak'))

function Main(props) {
  let MyApp = withRouter(App);
  return (
    <div>
      <div>
        <MyApp
          appName="fitnessMember"
          topBarUrl="/shiyan/fitness/api/v1/fitnessMember/menu/getTopBarInfo"
        >
          <Switch>
            {/* 注册 */}
            <Route path="/register" component={teacher}></Route>
            {/* <Redirect to="/fitness-home"  from='/'/> */}
            {/* 首页 */}
            <Route path="/fitness-home*" component={Portal} />
            {/* <Route path="/register/teacher" component={teacher} /> */}
            <Route path="/myNotice*" component={MyNotice}></Route>
            <Route path="/clubDetail/:clubId*" component={ClubDetail}></Route>
            <Route path="/fitness-team/:teamId*" component={PortalTeam}></Route>
            <Route path="/message" component={More}></Route>
            <Route path='/fitness-bespeak/:teamId*' component={Bespeak}></Route>
          </Switch>
        </MyApp>
      </div>
    </div>
  );
}
export default Main;
